import { useNavigate } from 'react-router-dom';
import { MarkdownPreview } from '@/components/ui/MarkdownPreview/MarkdownPreview';
import { Icon } from '@/components/ui/Icon/Icon';
import { useSession } from '@/services/auth';
import { useUIStore } from '@/stores/uiStore';
import { useCabinDocument } from '@/services/documents';
import { nb } from '@/i18n/nb';
import s from './OmHytta.module.css';

/*
 * Public Om hytta view, rendered inside the landing slide-overlay. Content comes from the
 * cabin_documents row (slug om-hytta) and is shown in the Great Vibes "letter" treatment.
 * In Rediger mode an admin sees a "Rediger innhold" affordance that opens the editor.
 */
export function OmHytta() {
  const navigate = useNavigate();
  const { user } = useSession();
  const editMode = useUIStore((state) => state.editMode);
  const { data: doc, isLoading, isError } = useCabinDocument('om-hytta');

  const canEdit = editMode && user?.role === 'admin';

  if (isLoading) return <p className={s.status} aria-live="polite" />;
  if (isError || !doc) return <p className={s.status}>{nb.documents.loadError}</p>;

  return (
    <div className={s.omHytta}>
      {canEdit && (
        <div className={s.editRow}>
          <button
            type="button"
            className={s.editBtn}
            onClick={() => navigate('/admin/innhold/om-hytta', { state: { from: 'public' } })}
          >
            <Icon name="pencil" size={16} /> {nb.documents.omHytta.editContent}
          </button>
        </div>
      )}
      <MarkdownPreview markdown={doc.content} variant="display" />
    </div>
  );
}
